const scientificProgramLinks = [
  { name: "Academic Agenda", link: "/scientific-program" },
  { name: "Pre-conference Workshops", link: "/workshop" },
  { name: "Call for Podium Awards", link: "/podium_awards" },
  { name: "Call for Abstracts", link: "/call-for-abstracts" },
  { name: "Call for Symposium", link: "/call-for-symposium" },
  { name: "Call for Panel Discussion", link: "/call-for-panel-discussion" },
  { name: "Call for Postgraduate Quiz Competition", link: "/call-for-quiz-competition" },
];

export default scientificProgramLinks;
